export default "__VITE_ASSET__68C_OZZu__"